import React, { useState, useRef, useEffect } from 'react';
import { Button, Popper, Paper, ClickAwayListener } from '@mui/material';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import styles from './categoryDropdown.module.css';

export default function CategoryDropdown({ treeData, selected, setSelected }) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const [_, setExpandedIds] = useState([]);
    const containerRef = useRef(null);
    const selectedNodeRef = useRef(null);
    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    useEffect(() => {
        if (!containerRef.current) return;
        const selectedEl = containerRef.current.querySelector('[aria-selected="true"]');
        if (selectedEl) {
            const container = containerRef.current;
            const nodeOffsetTop = selectedEl.offsetTop;
            const nodeHeight = selectedEl.offsetHeight;
            const containerHeight = container.clientHeight;
            const scrollTop = nodeOffsetTop - (containerHeight / 2) + (nodeHeight / 2);
            container.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }
    }, [selected]);

    function getAllNodeIds(tree) {
        const ids = [];

        function traverse(nodes) {
            nodes.forEach(node => {
                ids.push(node.id);
                if (node.children) {
                    traverse(node.children);
                }
            });
        }

        traverse(tree);
        return ids;
    }

    useEffect(() => {
        if (treeData.length > 0) {
            const allIds = getAllNodeIds(treeData);
            setExpandedIds(allIds);
        }
    }, [treeData]);
    return (
        <div className={styles.wrapper}>
            <Button
                variant="outlined"
                sx={{
                    width: '100%',
                    height: '25px',
                    fontSize: '16px',
                    minWidth: '200px',
                    color: 'black',
                    borderColor: 'black',
                    backgroundColor: '#FFFFFF',
                    '&:hover': {
                        borderColor: 'black',
                        backgroundColor: 'rgba(0,0,0,0.08)',
                    },
                }}
                onClick={handleToggle}
                ref={anchorRef}
            >
                {selected.length > 0 ? selected.join(', ') : 'Kategorien auswählen'}
            </Button>

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom-start"
                className={styles.popperContainer}
                disablePortal={false}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper ref={containerRef} className={styles.treePaper}>
                        <RichTreeView
                            items={treeData}
                            multiSelect
                            selectedItems={selected}
                            onSelectedItemsChange={(e, items) => setSelected(items)}
                            expandedIds={getAllNodeIds(treeData)}
                            onExpandedItemsChange={(e, ids) => setExpandedIds(ids)}
                            // Pass a renderLabel or use getTreeItemProps to add a ref to selected node
                            getTreeItemProps={(item) => ({
                                ref: selected.includes(item.id) ? selectedNodeRef : null,
                            })}
                        />
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </div>
    );
}
